// @flow
import * as React from 'react';
import _ from 'lodash';
import HashMap from '../protocol/HashMap';
// import Form from "../common/form/Form";
import StringUtil from '../util/StringUtil';
import moment from 'moment';
import Form from '../common/form/MetadataForm';
import VideoController from '../video/VideoController';
import { toSMPTE, toSMPTENoFrames, smpteToMillis } from '../util/VideoUtil';
import t from '../i18n/I18n';
import Store from '../store/Store';
import MetadataUtil from '../util/MetadataUtil';
const debug = require('../debug/debug')('wc:video:renderMetadataForm');

type SearchType = 'KEYS' | 'VALUES' | 'ALL';

const renderedWarnings = {};
function debugOnce(...args) {
  if (!renderedWarnings[args[0]]) {
    renderedWarnings[args[0]] = true;
    debug(...args);
  }
}

const BLACKLIST_LABELS = [
  /^id$/,
  /^id_/,
  /Id$/,
  /^_cid$/,
  /^_id$/,
  /^_assetAiDataModel$/,
  /^_boundingBoxes$/,
  /^_endTime$/,
  /^_startTime$/,
  /^_value$/,
  /^_boundingBox$/,
  /^_properties$/,
  /^isKeyFrameData$/,
  /^_timecode$/
];
function isBlacklisted(label: string) {
  for (let i = 0; i < BLACKLIST_LABELS.length; i++) {
    if (BLACKLIST_LABELS[i].test(label)) {
      return true;
    }
  }
  return false;
}

function i18nKey(key: string): string {
  if ('startTimeMs' === key) {
    return t('DATAPOINT_START');
  } else if ('stopTimeMs' === key) {
    return t('DATAPOINT_STOP');
  } else if ('value' === key) {
    return t('VALUE');
  }
  return key;
}

const READONLY_LABELS = ['confidence', 'key'];
function isReadonly(label: string) {
  return _.includes(READONLY_LABELS, label);
}

const HIDE_LABEL = ['key'];
function hideLabel(label: string) {
  return _.includes(HIDE_LABEL, label);
}

function getType(item: Object, groupCode: string) {
  const metadataType = MetadataUtil.getMetadataValueType(item.key, groupCode);
  if (metadataType === 'date') {
    return Form.Types.DATE;
  } else if (/Date/.test(item.key)) {
    return Form.Types.DATE;
  }
  return Form.Types.TEXT;
}

export function isTypeTime(key: string): boolean {
  if ('startTimeMs' === key || 'stopTimeMs' === key) {
    return true;
  }
  return false;
}

function validateFields(label, key) {
  /*switch (label) {
    case 'startTimeMs':
    case 'stopTimeMs':
      const validate = isNaN(key);
      return validate;
  }*/
  return false;
}

function convertMetadataToField(
  item: Object,
  pattern: string = '',
  searchType: ?SearchType,
  sort: boolean,
  disabled: boolean,
  videoController: VideoController,
  groupCode: string = ''
) {
  let { key, value, type, ...rest } = item;

  if (isBlacklisted(key)) {
    debugOnce(`[renderField()] field with key "${key}" has been configured to be hidden`);
    return null;
  }

  let field = null;
  if (!value) {
    value = '';
  }
  if (typeof value === 'object') {
    let fields = _.compact(
      Object.keys(value).map((key) =>
        convertMetadataToField(
          { key, value: value[key], ...rest },
          pattern,
          searchType,
          sort,
          disabled,
          videoController
        )
      )
    );

    if (!fields.length) {
      return null;
    }
    if (sort) {
      fields = _.sortBy(fields, (f) => f.label.toLowerCase());
    }

    field = {
      type: Form.Types.SUBFIELD,
      label: key,
      fields
    };
  } else {
    const type = item.type || getType(item, groupCode);
    if (type === Form.Types.DATE) {
      field = {
        type,
        label: i18nKey(key),
        key: key,
        selected: moment(parseInt(value, 10)),
        disabled: disabled || isReadonly(key),
        hideLabel: hideLabel(key),
        value: moment(parseInt(value, 10)).format('MM/DD/YYYY'),
        ...rest
      };
    } else if (false) {
      const newValue: string = value
        ? toSMPTE(videoController.videoStartTimecode + value, videoController.frameRate)
        : '0';
      console.log(
        'Formatted value:',
        newValue,
        smpteToMillis(newValue, videoController.frameRate),
        toSMPTE(smpteToMillis(newValue, videoController.frameRate), videoController.frameRate)
      );
      field = {
        type,
        key: key,
        label: i18nKey(key),
        value: value ? toSMPTE(videoController.videoStartTimecode + value, videoController.frameRate) : 0,
        disabled: disabled || isReadonly(key),
        hideLabel: hideLabel(key),
        invalid: validateFields(key, value),
        ...rest
      };
    } else {
      let val = Array.isArray(value) ? JSON.stringify(value) : value;
      if (
        val &&
        StringUtil.contains(key, 'size') &&
        'number' === MetadataUtil.getMetadataValueType(item.key, groupCode)
      ) {
        val = StringUtil.prettyBytes(val);
      }
      field = {
        type: 'TextBox',
        key: key,
        label: i18nKey(key),
        value: val,
        disabled: disabled || isReadonly(key),
        hideLabel: hideLabel(key),
        invalid: validateFields(key, val),
        ...rest
      };
    }

    if (pattern) {
      let patternNotFoundInKey = false,
        patternNotFoundInValue = false;

      let searchValueString: Array<string> = pattern.trim().replace(/\s+/g, ' ');
      let searchArrayValue = [];
      if (searchValueString[0] == '"' && searchValueString[searchValueString.length - 1] == '"') {
        searchValueString = searchValueString.replace(/(^"|"$)/g, '');
        searchArrayValue = [searchValueString];
      } else {
        searchArrayValue = searchValueString.split(' ');
      }

      const searchType0 = searchType ? searchType : 'ALL';
      if (
        searchType0 === 'ALL' &&
        (StringUtil.containsInArray(searchArrayValue, key) || StringUtil.containsInArray(searchArrayValue, value))
      ) {
        patternNotFoundInKey = true;
        patternNotFoundInValue = true;
      } else if (searchType0 === 'VALUES' && StringUtil.containsInArray(searchArrayValue, value)) {
        patternNotFoundInKey = true;
      } else if (searchType0 === 'KEYS' && StringUtil.containsInArray(searchArrayValue, key)) {
        patternNotFoundInValue = true;
      } else {
        return null;
      }
    }
  }
  //$FlowIgnore
  field.__data = value;

  return field;
}

export default function renderMetadataForm(
  metadata: HashMap | Object[],
  onChange: Function,
  showTimeline: boolean = false,
  sort: boolean = true,
  onDelete?: Function,
  disabled: boolean = false,
  className: string = '',
  pattern: string = '',
  searchType: ?SearchType,
  onLocateClick: ?Function,
  videoController: VideoController,
  groupCode: string = '',
  fromComponent: string = ''
) {
  let metadataArr;
  if (Array.isArray(metadata)) {
    metadataArr = metadata.map((value) => ({ value }));
  } else {
    metadataArr = metadata.toArray();
  }

  let fields = _.compact(
    metadataArr.map((item) =>
      convertMetadataToField(item, pattern, searchType, sort, disabled, videoController, groupCode)
    )
  );

  if (!fields.length) {
    return null;
  }

  if (sort) {
    fields = _.sortBy(fields, (f) => f.label.toLowerCase());
  }
  let autoCompleteProp =
    fromComponent == 'TimelinePopup'
      ? {
          value: fields[3] ? fields[3].value : '',
          metadataKeyName: fields[0] ? fields[0].value : '',
          itemsLength: 1,
          disabled: fields[3] ? fields[3].disabled : '',
          fromComponent: 'TimelinePopup'
        }
      : null;
  return (
    <Form
      className={className}
      fields={fields}
      pattern={pattern}
      searchType={searchType}
      showTimeline={showTimeline}
      disabled={disabled}
      onChange={onChange}
      onLocateClick={onLocateClick}
      onDelete={onDelete}
      autoCompleteProp={autoCompleteProp}
      fromComponent={fromComponent}
    />
  );
}
